{
	"backToManageDeclarations": "Torna a Gestisci dichiarazioni"
}
